import React from 'react'
import PropTypes from 'prop-types'
import { Progress, Container, Image } from 'components/qstrap'

const AptitudeProgressBar = ({
  page, maxPage, pageName, answeredCount, questionsSize,
}) => {
  const barValue = (answeredCount / questionsSize) * 100
  const nextPage = page >= maxPage ? <Image src="/assets/img/aptitude/finish.png" /> : (page + 1)

  return (
    <div className="AptitudeProgressBar">
      <Container>
        <div className="progress-title">
          <b className="">{pageName}</b>
          <b className="page-indicator">{page}/{maxPage}</b>
        </div>
        <div>
          <div className="numberCircle pull-left">{page}</div>
          <div className="numberCircle pull-right">{nextPage}</div>
          <div className="progress-container">
            <Progress value={barValue} />
          </div>
        </div>
      </Container>
    </div>
  )
}

AptitudeProgressBar.propTypes = {
  page: PropTypes.number.isRequired,
  maxPage: PropTypes.number.isRequired,
  pageName: PropTypes.string.isRequired,
  answeredCount: PropTypes.number.isRequired,
  questionsSize: PropTypes.number.isRequired,
}

export default AptitudeProgressBar
